<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.deviceName }}</td>
          <td>{{ item.uuid }}</td>
          <td class="px-2 tableSelectCursor" @click="((modalQR = true), (mobileDevice = { ...item }))">
            <v-icon>{{ mdiQrcodeScan }} </v-icon>
          </td>
          <td
            v-if="$store.state.auth.userSettings.accMobileDevices.update"
            class="px-2 tableSelectCursor"
            @click="((modalEdit = true), (mobileDevice = { ...item }), (newMobileDevice = false))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accMobileDevices.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="modalEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.mobileDevice') }}
          <v-spacer />
          <v-icon large @click="modalEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="mobileDeviceForm">
            <v-row>
              <v-col>
                <v-text-field
                  :label="$t('label.itemName')"
                  v-model="mobileDevice.name"
                  :rules="[ruleRequired]"
                  maxlength="128"
                  hide-details
                  dense
                  autofocus
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="mobileDevice.areas"
                  :label="$tc('label.area', 2)"
                  :items="listAreas"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ minWidth: '500' }"
                  :rules="[ruleArray]"
                  :return-object="false"
                  multiple
                  chips
                  deletable-chips
                  append-icon
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('label.UUID')" v-model="mobileDevice.uuid" disabled hide-details dense />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('label.device')" v-model="mobileDevice.deviceName" disabled hide-details dense />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  :label="$t('label.note')"
                  v-model="mobileDevice.note"
                  name="input-7-1"
                  no-resize
                  maxlength="512"
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox v-model="mobileDevice.allowExit" class="my-0 py-0" :label="$t('label.allowSetDeparture')" hide-details dense />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn
            v-if="!newMobileDevice && $store.state.auth.userSettings.accMobileDevices.delete"
            color="colorDelete"
            @click="modalDelete = true"
          >
            {{ $tc('btn.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="colorSave" @click="dataSave">{{ $tc('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalQR" max-width="400px">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $tc('label.mobileDeviceSettings') }}</v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col>
              <v-img width="350px" height="350px" :src="`/api/v1/mobileqr/${mobileDevice.uuid}`" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn tile color="colorClose" @click="modalQR = false">{{ $tc('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${mobileDevice.name}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiMagnify, mdiQrcodeScan, mdiPen, mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsMobileDevices',
  components: { DialogConfirmDelete },
  data: () => ({
    modalEdit: false,
    modalQR: false,
    modalDelete: false,
    newMobileDevice: false,
    validForm: false,
    tableData: [],
    listAreas: [],
    search: '',
    mobileDevice: {
      uuid: 0,
      name: '',
      allowExit: false,
      note: '',
      areas: [] as any,
      deviceName: '',
    },
    mdiMagnify: mdiMagnify,
    mdiQrcodeScan: mdiQrcodeScan,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleArray() {
      return (v: any) => !!(v.length > 0) || this.$i18n.t('msg.fieldIsMandatory');
    },
    headers: function () {
      return [
        { text: this.$i18n.tc('label.itemName'), value: 'name' },
        { text: this.$i18n.tc('label.device'), value: 'deviceName' },
        { text: this.$i18n.tc('label.UUID'), value: 'uuid' },
        { sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
      ];
    },
  },
  mounted() {
    this.listAreasLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/mobiledevice')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      axios
        .get('/api/v1/uuid')
        .then((response) => {
          const getDefaults: any = this.$options;
          this.mobileDevice = { ...getDefaults.data().mobileDevice };
          this.mobileDevice.uuid = response.data.uuid;
          this.newMobileDevice = true;
          this.modalEdit = true;
          this.$nextTick(function () {
            const form: any = this.$refs.mobileDeviceForm;
            form.validate();
          });
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      const form: any = this.$refs.mobileDeviceForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.newMobileDevice) {
          axios
            .post('/api/v1/mobiledevice', this.mobileDevice)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
          this.newMobileDevice = false;
        } else {
          axios
            .put('/api/v1/mobiledevice', this.mobileDevice)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/mobiledevice/${this.mobileDevice.uuid}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalDelete = false;
      this.modalEdit = false;
    },
    listAreasLoad() {
      axios
        .get('/api/v1/area')
        .then((response) => {
          this.listAreas = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
